// extracted by mini-css-extract-plugin
export default {"notice":"DuplicateEmailNotice_notice__FUcQy"};